import React, { StyleHTMLAttributes } from 'react';

import { mergeDeepRight } from 'ramda';
import { Arrow, ToggleLayerOptions, useToggleLayer } from 'react-laag';

import Dropdown from 'components/shared/Dropdown';

import cs from '../index.module.css';

type Props = React.PropsWithChildren<
  {
    content: React.ReactNode;
    containerClassName?: StyleHTMLAttributes<HTMLDivElement>['className'];
  } & ToggleLayerOptions
>;

const baseOptions: ToggleLayerOptions = {
  placement: {
    anchor: 'TOP_CENTER',
    autoAdjust: false,
    triggerOffset: 10,
  },
  closeOnOutsideClick: true,
  fixed: true,
};

export const TooltipDialog = function ({ children, content, containerClassName, ...toggleOptions }: Props) {
  const options = mergeDeepRight(baseOptions, toggleOptions) as ToggleLayerOptions;

  const [element, toggleLayerProps] = useToggleLayer(
    ({ isOpen, layerProps, arrowStyle, layerSide }) =>
      isOpen && (
        <div ref={layerProps.ref} style={{ ...layerProps.style, zIndex: 999 }} className={containerClassName}>
          <Dropdown className={cs.dropdown}>{content}</Dropdown>
          <Arrow
            style={{ ...arrowStyle, zIndex: '22' }}
            layerSide={layerSide}
            borderWidth={1}
            borderColor="rgba(0, 0, 0, 0.04)"
            backgroundColor="#fff"
            angle={50}
            roundness={0.5}
            size={6}
          />
        </div>
      ),
    options,
  );

  return (
    <React.Fragment>
      {element}
      <div onClick={toggleLayerProps.openFromMouseEvent}>{children}</div>
    </React.Fragment>
  );
};
